import React, { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const TenantContext = createContext(null);

export function TenantProvider({ children }) {
  const [data, setData] = useState(null);
  useEffect(() => {
    api.get("/tenant/atlas").then((r) => setData(r.data)).catch(() => {});
  }, []);
  return <TenantContext.Provider value={data}>{children}</TenantContext.Provider>;
}

export const useTenant = () => useContext(TenantContext);
